import React from 'react';
import { Tabs } from './Tabs';

export function TabsExample(): JSX.Element {
  return (
    <>
      <Tabs
        tabGroups={[
          [
            { title: 'Overview', active: true, path: '/styleguide' },
            { title: 'Event', path: '/styleguide' },
            { title: 'Venue & contingent', path: '/styleguide' },
            { title: 'Ticket', path: '/styleguide' },
            { title: 'Stats', path: '/styleguide' },
            { title: 'Billing', path: '/styleguide' },
          ],
          [
            { title: 'Shop/content', disabled: true, path: '/styleguide' },
            { title: 'Review', disabled: true, path: '/styleguide' },
          ],
        ]}
      />
      <Tabs
        displayAsPills
        tabGroups={[
          [
            { title: 'Print tickets', active: true, path: '/styleguide' },
            { title: 'Local pricing', path: '/styleguide' },
            { title: 'System pricing', path: '/styleguide' },
            { title: 'Design', path: '/styleguide' },
          ],
        ]}
      />
    </>
  );
}
